// sk-SK
export default {
	title: "Centrum darčekových kariet",
	myPoints: "Moje body",
	SelectedGifts: "Vybrané dary",
	form: {
		label: {
			title: "Vyhľadávanie",
			points: "Body"
		}
	},
	redemption: "Vykúpenie",
	stock: "Skladom",
	id: {
		redeemPoints: "Vymeniť potrebné body:",
		btn: "Vymeniť teraz",
		title: "Upozornenie na nákup",
		content: `Vážený pracovník, ďakujeme vám za vašu účasť na práci.\n\nPred uplatnením bodov si prečítajte nasledujúce podmienky:\n\n[Pracovné body] Po každodennom dokončení optimalizácie údajov sady objednávok môžu pracovníci získať 1 darčekový bod, ktorý môže použiť na čiastočné vyplatenie sponzorského daru.\n[Uplatnenie darčekov] Pracovníci musia poskytnúť relevantné informácie o dodacej adrese a darček bude do 14 dní odoslaný bezplatne do celého sveta. Po dokončení vyplatenia môžete kontaktovať zákaznícky servis a získať sledovacie číslo na sledovanie priebehu daru. Platforma nezverejní informácie tretím stranám.\nPoznámka: Keď budú body vymenené za darčeky, nie je možné ich vrátiť`
	},
	applyDialog: {
		title: "Prihlasovacie údaje",
		form: {
			consignee: "Príjemca",
			area: "Oblasť",
			telephone: "Telefón",
			deliveryAddress: "Dodacia adresa"
		},
		btn: "Odoslať"
	},
	records: {
		title: "Záznamy",
		status: ["Čaká sa na odoslanie", "Odoslané", "Dodané", "Zrušené"]
	}
};
